module.exports = __webpack_public_path__ + "web/img/grade-img.2ba4ba8e.png";